import * as S from "./style";
import React from "react";
import { useCampaign } from "../../context/CampaignContext";

function NextMatch(): React.ReactElement {
  const { campaignData } = useCampaign();


  return (
    <S.NextMatchContainer>
      <S.NextMatchTitle>
        <span>
          Próximo jogo
        </span>
      </S.NextMatchTitle>
      <S.Players>
        <S.NextMatchPlayer>
          <img src={campaignData.teamShield} alt="escudo-casa" className="home" />
          <span>{campaignData.teamName}</span>
        </S.NextMatchPlayer>
        <span>X</span>
      </S.Players>
    </S.NextMatchContainer>
  );
}

export default NextMatch;
